<template>
    <vx-card class="p-2" style="width: 300px;">
        <!-- AVATAR -->
        <div class="vx-row">
        <vs-avatar
            style="border: 1px solid;"
            class="mx-auto mb-6 block"
            size="80px"
            :src="collaboratorAvatar"
        />
        </div>
        <!-- FULL NAME AND TITLE -->
        <div class="text-center vx-row mx-auto justify-center">
            <h4>{{ collaborator.firstname }} {{ collaborator.lastname }}</h4>
        </div>
        <div class="text-center vx-row mx-auto justify-center">
            <p>{{ getCollaboratorTypeForClient(collaborator.user_type) }}</p>
        </div>
        <div class="text-center vx-row mx-auto justify-center" v-if="$acl.check('sadmin')">
            <vs-chip
            style="width: 80px"
            :color="getContractStatusColor(collaborator.status)"
            class="ml-2"
            >{{
            getStatus(collaborator.status)
            }}</vs-chip>
        </div>
        <!-- PHONE -->
        <div class="vx-row mt-2 flex justify-between">
        <div class="flex items-center">
            <span class="ml-2">Tél : {{ collaborator.phone }}</span>
        </div>
        </div>
        <!-- MAIL -->
        <div class="vx-row flex justify-between">
        <div class="flex items-center">
            <span class="ml-2">Email : <a :href="'mailto:' + collaborator.email">{{ collaborator.email }}</a></span>
        </div>
        </div>
        <!-- COMMENT -->
        <!-- <div class="vx-row flex justify-between">
        <div class="flex items-center">
            <span class="ml-2">Commentaire : {{ collaborator.commentary }}</span>
        </div>
        </div> -->
        <!-- BUTTONS -->
        <!-- <div
        class=" vx-row flex justify-between flex-wrap"
        v-if="$acl.check('sadmin')"
        >
        <vs-button
            color="primary"
            class="mt-4 shadow-lg vx-col w-1/3"
            icon-pack="feather"
            icon="icon-edit"
            @click="modifyCollaborator(collaborator.id)"
        />
        <vs-button
            class="mt-4 mr-2 vx-col w-1/3"
            type="border"
            color="danger"
            icon-pack="feather"
            icon="icon-trash-2"
            @click="displayValidationPopup(collaborator.id)"
            />
        </div> -->
    </vx-card>
</template>

<script>
import fieldConvertorMixin from "@/mixins/dbFieldConvertorMixin";

export default {
	name: "UserCard",
	mixins: [fieldConvertorMixin],
	props: {
		collaborator: {
			type: Object,
			default: null
		},
		collaboratorAvatar: {
			type: String,
			default: null
		}
	},
	data(){
		return {

		};
	},
	methods: {

		/*
		 * modifyCollaborator(collaboratorId){
		 *     let updateEntityForm = "collaborator"
		 *     this.$router.push({ name: 'update_entity', params: { collaboratorId, updateEntityForm } })
		 *     //console.log("modifyCollaborator")
		 * },
		 * displayValidationPopup(collaboratorId){
		 *     this.selectedCollaborator = collaboratorId
		 *     this.showValidationPopup = true
		 * },
		 */
	},
};
</script>
